const actionTypeIdentifier = '825cfd88-c4b0-4566-b4bb-58ee1e34626e';

export const getViewMilestoneDetails= `GET-VIEW-MILESTONE-DETAILS-${actionTypeIdentifier}`;

export const setMilestoneError= `GET-VIEW-MILESTONE-DETAILS-${actionTypeIdentifier}`;

export const getMilestoneCircuitStatusesDropdown= `GET-MILESTONE-CIRCUIT-STATUS-DROPDOWN${actionTypeIdentifier}`;

export const orderMilestoneModel= {
    orderSubmitDate: null,
    circuitRequestedDate: null,
    carrierConfirmationDate: null,
    carrierTrackingID: '',
    telcoRepresentativeAssigned: '',
    vendorCommitmentDeliveryDate: null,
    installOrdisconnectDate: null,
    orderClosedDate: null,
    orderType: ""
};